/** Superadmin manages channels without being a member — never default to leave. */
export const initialIsOptedOut = ({ isEdit, isSuperAdmin, isMember }) =>
  isEdit && !isSuperAdmin && !isMember ? ['on'] : [];

/** Do not drop a channel from the sidebar after edit when the editor is superadmin. */
export const shouldRemoveChannelAfterUpdate = ({ isMember, isSuperAdmin }) =>
  !isMember && !isSuperAdmin;

/** Keep sidebar visibility for superadmin after an update that returns isMember:false. */
export const channelAfterUpdate = (rawChannel, isSuperAdmin) =>
  isSuperAdmin && !rawChannel.isMember ? { ...rawChannel, isMember: true } : rawChannel;
